const timeInfo = {
    timeZones: [
        'Europe/Andorra',
        'Asia/Dubai',
        'Asia/Kabul',
        'Europe/Tirane',
        'Asia/Yerevan',
        'Antarctica/Casey',
        'Antarctica/Davis',
        'Antarctica/DumontDUrville', // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
        'Antarctica/Mawson',
        'Antarctica/Palmer',
        'Antarctica/Rothera',
        'Antarctica/Syowa',
        'Antarctica/Troll',
        'Antarctica/Vostok',
        'America/Argentina/Buenos_Aires',
        'America/Argentina/Cordoba',
        'America/Argentina/Salta',
        'America/Argentina/Jujuy',
        'America/Argentina/Tucuman',
        'America/Argentina/Catamarca',
        'America/Argentina/La_Rioja',
        'America/Argentina/San_Juan',
        'America/Argentina/Mendoza',
        'America/Argentina/San_Luis',
        'America/Argentina/Rio_Gallegos',
        'America/Argentina/Ushuaia',
        'Pacific/Pago_Pago',
        'Europe/Vienna',
        'Australia/Lord_Howe',
        'Antarctica/Macquarie',
        'Australia/Hobart',
        'Australia/Currie',
        'Australia/Melbourne',
        'Australia/Sydney',
        'Australia/Broken_Hill',
        'Australia/Brisbane',
        'Australia/Lindeman',
        'Australia/Adelaide',
        'Australia/Darwin',
        'Australia/Perth',
        'Australia/Eucla',
        'Asia/Baku',
        'America/Barbados',
        'Asia/Dhaka',
        'Europe/Brussels',
        'Europe/Sofia',
        'Atlantic/Bermuda',
        'Asia/Brunei',
        'America/La_Paz',
        'America/Noronha',
        'America/Belem',
        'America/Fortaleza',
        'America/Recife',
        'America/Araguaina',
        'America/Maceio',
        'America/Bahia',
        'America/Sao_Paulo',
        'America/Campo_Grande',
        'America/Cuiaba',
        'America/Santarem',
        'America/Porto_Velho',
        'America/Boa_Vista',
        'America/Manaus',
        'America/Eirunepe',
        'America/Rio_Branco',
        'America/Nassau',
        'Asia/Thimphu',
        'Europe/Minsk',
        'America/Belize',
        'America/St_Johns',
        'America/Halifax',
        'America/Glace_Bay',
        'America/Moncton',
        'America/Goose_Bay',
        'America/Blanc-Sablon',
        'America/Toronto',
        'America/Nipigon',
        'America/Thunder_Bay',
        'America/Iqaluit',
        'America/Pangnirtung',
        'America/Atikokan',
        'America/Winnipeg',
        'America/Rainy_River',
        'America/Resolute',
        'America/Rankin_Inlet',
        'America/Regina',
        'America/Swift_Current',
        'America/Edmonton',
        'America/Cambridge_Bay',
        'America/Yellowknife',
        'America/Inuvik',
        'America/Creston',
        'America/Dawson_Creek',
        'America/Fort_Nelson',
        'America/Vancouver',
        'America/Whitehorse',
        'America/Dawson',
        'Indian/Cocos',
        'Europe/Zurich',
        'Africa/Abidjan',
        'Pacific/Rarotonga',
        'America/Santiago',
        'America/Punta_Arenas',
        'Pacific/Easter',
        'Asia/Shanghai',
        'Asia/Urumqi',
        'America/Bogota',
        'America/Costa_Rica',
        'America/Havana',
        'Atlantic/Cape_Verde',
        'America/Curacao',
        'Indian/Christmas',
        'Asia/Nicosia',
        'Asia/Famagusta',
        'Europe/Prague',
        'Europe/Berlin',
        'Europe/Copenhagen',
        'America/Santo_Domingo',
        'Africa/Algiers',
        'America/Guayaquil',
        'Pacific/Galapagos',
        'Europe/Tallinn',
        'Africa/Cairo',
        'Africa/El_Aaiun',
        'Europe/Madrid',
        'Africa/Ceuta',
        'Atlantic/Canary',
        'Europe/Helsinki',
        'Pacific/Fiji',
        'Atlantic/Stanley',
        'Pacific/Chuuk',
        'Pacific/Pohnpei',
        'Pacific/Kosrae',
        'Atlantic/Faroe',
        'Europe/Paris',
        'Europe/London',
        'Asia/Tbilisi',
        'America/Cayenne',
        'Africa/Accra',
        'Europe/Gibraltar',
        'America/Godthab',
        'America/Danmarkshavn',
        'America/Scoresbysund',
        'America/Thule',
        'Europe/Athens',
        'Atlantic/South_Georgia',
        'America/Guatemala',
        'Pacific/Guam',
        'Africa/Bissau',
        'America/Guyana',
        'Asia/Hong_Kong',
        'America/Tegucigalpa',
        'America/Port-au-Prince',
        'Europe/Budapest',
        'Asia/Jakarta',
        'Asia/Pontianak',
        'Asia/Makassar',
        'Asia/Jayapura',
        'Europe/Dublin',
        'Asia/Jerusalem',
        'Asia/Kolkata',
        'Indian/Chagos',
        'Asia/Baghdad',
        'Asia/Tehran',
        'Atlantic/Reykjavik',
        'Europe/Rome',
        'America/Jamaica',
        'Asia/Amman',
        'Asia/Tokyo',
        'Africa/Nairobi',
        'Asia/Bishkek',
        'Pacific/Tarawa',
        'Pacific/Enderbury',
        'Pacific/Kiritimati',
        'Asia/Pyongyang',
        'Asia/Seoul',
        'Asia/Almaty',
        'Asia/Qyzylorda',
        'Asia/Qostanay', // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
        'Asia/Aqtobe',
        'Asia/Aqtau',
        'Asia/Atyrau',
        'Asia/Oral',
        'Asia/Beirut',
        'Asia/Colombo',
        'Africa/Monrovia',
        'Europe/Vilnius',
        'Europe/Luxembourg',
        'Europe/Riga',
        'Africa/Tripoli',
        'Africa/Casablanca',
        'Europe/Monaco',
        'Europe/Chisinau',
        'Pacific/Majuro',
        'Pacific/Kwajalein',
        'Asia/Yangon',
        'Asia/Ulaanbaatar',
        'Asia/Hovd',
        'Asia/Choibalsan',
        'Asia/Macau',
        'America/Martinique',
        'Europe/Malta',
        'Indian/Mauritius',
        'Indian/Maldives',
        'America/Mexico_City',
        'America/Cancun',
        'America/Merida',
        'America/Monterrey',
        'America/Matamoros',
        'America/Mazatlan',
        'America/Chihuahua',
        'America/Ojinaga',
        'America/Hermosillo',
        'America/Tijuana',
        'America/Bahia_Banderas',
        'Asia/Kuala_Lumpur',
        'Asia/Kuching',
        'Africa/Maputo',
        'Africa/Windhoek',
        'Pacific/Noumea',
        'Pacific/Norfolk',
        'Africa/Lagos',
        'America/Managua',
        'Europe/Amsterdam',
        'Europe/Oslo',
        'Asia/Kathmandu',
        'Pacific/Nauru',
        'Pacific/Niue',
        'Pacific/Auckland',
        'Pacific/Chatham',
        'America/Panama',
        'America/Lima',
        'Pacific/Tahiti',
        'Pacific/Marquesas',
        'Pacific/Gambier',
        'Pacific/Port_Moresby',
        'Pacific/Bougainville',
        'Asia/Manila',
        'Asia/Karachi',
        'Europe/Warsaw',
        'America/Miquelon',
        'Pacific/Pitcairn',
        'America/Puerto_Rico',
        'Asia/Gaza',
        'Asia/Hebron',
        'Europe/Lisbon',
        'Atlantic/Madeira',
        'Atlantic/Azores',
        'Pacific/Palau',
        'America/Asuncion',
        'Asia/Qatar',
        'Indian/Reunion',
        'Europe/Bucharest',
        'Europe/Belgrade',
        'Europe/Kaliningrad',
        'Europe/Moscow',
        'Europe/Simferopol',
        'Europe/Kirov',
        'Europe/Astrakhan',
        'Europe/Volgograd',
        'Europe/Saratov',
        'Europe/Ulyanovsk',
        'Europe/Samara',
        'Asia/Yekaterinburg',
        'Asia/Omsk',
        'Asia/Novosibirsk',
        'Asia/Barnaul',
        'Asia/Tomsk',
        'Asia/Novokuznetsk',
        'Asia/Krasnoyarsk',
        'Asia/Irkutsk',
        'Asia/Chita',
        'Asia/Yakutsk',
        'Asia/Khandyga',
        'Asia/Vladivostok',
        'Asia/Ust-Nera',
        'Asia/Magadan',
        'Asia/Sakhalin',
        'Asia/Srednekolymsk',
        'Asia/Kamchatka',
        'Asia/Anadyr',
        'Asia/Riyadh',
        'Pacific/Guadalcanal',
        'Indian/Mahe',
        'Africa/Khartoum',
        'Europe/Stockholm',
        'Asia/Singapore',
        'America/Paramaribo',
        'Africa/Juba',
        'Africa/Sao_Tome',
        'America/El_Salvador',
        'Asia/Damascus',
        'America/Grand_Turk',
        'Africa/Ndjamena',
        'Indian/Kerguelen',
        'Asia/Bangkok',
        'Asia/Dushanbe',
        'Pacific/Fakaofo',
        'Asia/Dili',
        'Asia/Ashgabat',
        'Africa/Tunis',
        'Pacific/Tongatapu',
        'Europe/Istanbul',
        'America/Port_of_Spain',
        'Pacific/Funafuti',
        'Asia/Taipei',
        'Europe/Kiev',
        'Europe/Uzhgorod',
        'Europe/Zaporozhye',
        'Pacific/Wake',
        'America/New_York',
        'America/Detroit',
        'America/Kentucky/Louisville',
        'America/Kentucky/Monticello',
        'America/Indiana/Indianapolis',
        'America/Indiana/Vincennes',
        'America/Indiana/Winamac',
        'America/Indiana/Marengo',
        'America/Indiana/Petersburg',
        'America/Indiana/Vevay',
        'America/Chicago',
        'America/Indiana/Tell_City',
        'America/Indiana/Knox',
        'America/Menominee',
        'America/North_Dakota/Center',
        'America/North_Dakota/New_Salem',
        'America/North_Dakota/Beulah',
        'America/Denver',
        'America/Boise',
        'America/Phoenix',
        'America/Los_Angeles',
        'America/Anchorage',
        'America/Juneau',
        'America/Sitka',
        'America/Metlakatla',
        'America/Yakutat',
        'America/Nome',
        'America/Adak',
        'Pacific/Honolulu',
        'America/Montevideo',
        'Asia/Samarkand',
        'Asia/Tashkent',
        'America/Caracas',
        'Asia/Ho_Chi_Minh',
        'Pacific/Efate',
        'Pacific/Wallis',
        'Pacific/Apia',
        'Africa/Johannesburg'
    ],

    localeCodes: [
        'af-ZA', // Afrikaans (South Africa)
        'am-ET', // Amharic (Ethiopia)
        'ar-AE', // Arabic (U.A.E.)
        'ar-BH', // Arabic (Bahrain)
        'ar-DZ', // Arabic (Algeria)
        'ar-EG', // Arabic (Egypt)
        'ar-IQ', // Arabic (Iraq)
        'ar-JO', // Arabic (Jordan)
        'ar-KW', // Arabic (Kuwait)
        'ar-LB', // Arabic (Lebanon)
        'ar-LY', // Arabic (Libya)
        'ar-MA', // Arabic (Morocco)
        'ar-OM', // Arabic (Oman)
        'ar-QA', // Arabic (Qatar)
        'ar-SA', // Arabic (Saudi Arabia)
        'ar-SY', // Arabic (Syria)
        'ar-TN', // Arabic (Tunisia)
        'ar-YE', // Arabic (Yemen)
        'az-Cyrl-AZ', // Azerbaijani (Cyrillic, Azerbaijan)
        'az-Latn-AZ', // Azerbaijani (Latin, Azerbaijan)
        'be-BY', // Belarusian (Belarus)
        'bg-BG', // Bulgarian (Bulgaria)
        'bn-BD', // Bengali (Bangladesh)
        'bn-IN', // Bengali (India)
        'bs-Cyrl-BA', // Bosnian (Cyrillic, Bosnia and Herzegovina)
        'bs-Latn-BA', // Bosnian (Latin, Bosnia and Herzegovina)
        'ca-ES', // Catalan (Spain)
        'cs-CZ', // Czech (Czech Republic)
        'cy-GB', // Welsh (United Kingdom)
        'da-DK', // Danish (Denmark)
        'de-AT', // German (Austria)
        'de-CH', // German (Switzerland)
        'de-DE', // German (Germany)
        'de-LI', // German (Liechtenstein)
        'de-LU', // German (Luxembourg)
        'dv-MV', // Divehi (Maldives)
        'el-GR', // Greek (Greece)
        'en-029', // English (Caribbean)
        'en-AU', // English (Australia)
        'en-BZ', // English (Belize)
        'en-CA', // English (Canada)
        'en-GB', // English (United Kingdom)
        'en-IE', // English (Ireland)
        'en-IN', // English (India)
        'en-JM', // English (Jamaica)
        'en-MY', // English (Malaysia)
        'en-NZ', // English (New Zealand)
        'en-PH', // English (Republic of the Philippines)
        'en-SG', // English (Singapore)
        'en-TT', // English (Trinidad and Tobago)
        'en-US', // English (United States)
        'en-ZA', // English (South Africa)
        'en-ZW', // English (Zimbabwe)
        'es-AR', // Spanish (Argentina)
        'es-BO', // Spanish (Bolivia)
        'es-CL', // Spanish (Chile)
        'es-CO', // Spanish (Colombia)
        'es-CR', // Spanish (Costa Rica)
        'es-DO', // Spanish (Dominican Republic)
        'es-EC', // Spanish (Ecuador)
        'es-ES', // Spanish (Spain)
        'es-GT', // Spanish (Guatemala)
        'es-HN', // Spanish (Honduras)
        'es-MX', // Spanish (Mexico)
        'es-NI', // Spanish (Nicaragua)
        'es-PA', // Spanish (Panama)
        'es-PE', // Spanish (Peru)
        'es-PR', // Spanish (Puerto Rico)
        'es-PY', // Spanish (Paraguay)
        'es-SV', // Spanish (El Salvador)
        'es-US', // Spanish (United States)
        'es-UY', // Spanish (Uruguay)
        'es-VE', // Spanish (Venezuela)
        'et-EE', // Estonian (Estonia)
        'eu-ES', // Basque (Spain)
        'fa-IR', // Persian (Iran)
        'fi-FI', // Finnish (Finland)
        'fil-PH', // Filipino (Philippines)
        'fo-FO', // Faroese (Faroe Islands)
        'fr-BE', // French (Belgium)
        'fr-CA', // French (Canada)
        'fr-CH', // French (Switzerland)
        'fr-FR', // French (France)
        'fr-LU', // French (Luxembourg)
        'fr-MC', // French (Monaco)
        'gl-ES', // Galician (Spain)
        'gu-IN', // Gujarati (India)
        'he-IL', // Hebrew (Israel)
        'hi-IN', // Hindi (India)
        'hr-BA', // Croatian (Bosnia and Herzegovina)
        'hr-HR', // Croatian (Croatia)
        'hu-HU', // Hungarian (Hungary)
        'hy-AM', // Armenian (Armenia)
        'id-ID', // Indonesian (Indonesia)
        'ig-NG', // Igbo (Nigeria)
        'ii-CN', // Sichuan Yi (China)
        'is-IS', // Icelandic (Iceland)
        'it-CH', // Italian (Switzerland)
        'it-IT', // Italian (Italy)
        'ja-JP', // Japanese (Japan)
        'ka-GE', // Georgian (Georgia)
        'kk-KZ', // Kazakh (Kazakhstan)
        'km-KH', // Khmer (Cambodia)
        'kn-IN', // Kannada (India)
        'ko-KR', // Korean (Korea)
        'kok-IN', // Konkani (India)
        'ky-KG', // Kyrgyz (Kyrgyzstan)
        'lb-LU', // Luxembourgish (Luxembourg)
        'lo-LA', // Lao (Lao P.D.R.)
        'lt-LT', // Lithuanian (Lithuania)
        'lv-LV', // Latvian (Latvia)
        'mi-NZ', // Maori (New Zealand)
        'mk-MK', // Macedonian (North Macedonia)
        'ml-IN', // Malayalam (India)
        'mn-MN', // Mongolian (Mongolia)
        'mr-IN', // Marathi (India)
        'ms-BN', // Malay (Brunei Darussalam)
        'ms-MY', // Malay (Malaysia)
        'mt-MT', // Maltese (Malta)
        'nb-NO', // Norwegian Bokmål (Norway)
        'ne-NP', // Nepali (Nepal)
        'nl-BE', // Dutch (Belgium)
        'nl-NL', // Dutch (Netherlands)
        'nn-NO', // Norwegian Nynorsk (Norway)
        'nso-ZA', // Sesotho sa Leboa (South Africa)
        'or-IN', // Odia (India)
        'pa-IN', // Punjabi (India)
        'pl-PL', // Polish (Poland)
        'prs-AF', // Dari (Afghanistan)
        'ps-AF', // Pashto (Afghanistan)
        'pt-BR', // Portuguese (Brazil)
        'pt-PT', // Portuguese (Portugal)
        'qut-GT', // K'iche' (Guatemala)
        'quz-BO', // Quechua (Bolivia)
        'quz-EC', // Quechua (Ecuador)
        'quz-PE', // Quechua (Peru)
        'ro-RO', // Romanian (Romania)
        'ru-RU', // Russian (Russia)
        'rw-RW', // Kinyarwanda (Rwanda)
        'sa-IN', // Sanskrit (India)
        'sah-RU', // Sakha (Russia)
        'se-FI', // Sami (Northern, Finland)
        'se-NO', // Sami (Northern, Norway)
        'se-SE', // Sami (Northern, Sweden)
        'si-LK', // Sinhala (Sri Lanka)
        'sk-SK', // Slovak (Slovakia)
        'sl-SI', // Slovenian (Slovenia)
        'sma-NO', // Sami (Southern, Norway)
        'sma-SE', // Sami (Southern, Sweden)
        'smj-NO', // Sami (Lule, Norway)
        'smj-SE', // Sami (Lule, Sweden)
        'smn-FI', // Sami (Inari, Finland)
        'sms-FI', // Sami (Skolt, Finland)
        'sq-AL', // Albanian (Albania)
        'sr-Cyrl-BA', // Serbian (Cyrillic, Bosnia and Herzegovina)
        'sr-Cyrl-CS', // Serbian (Cyrillic, Serbia and Montenegro (Former))
        'sr-Cyrl-ME', // Serbian (Cyrillic, Montenegro)
        'sr-Cyrl-RS', // Serbian (Cyrillic, Serbia)
        'sr-Latn-BA', // Serbian (Latin, Bosnia and Herzegovina)
        'sr-Latn-CS', // Serbian (Latin, Serbia and Montenegro (Former))
        'sr-Latn-ME', // Serbian (Latin, Montenegro)
        'sr-Latn-RS', // Serbian (Latin, Serbia)
        'sv-FI', // Swedish (Finland)
        'sv-SE', // Swedish (Sweden)
        'sw-KE', // Kiswahili (Kenya)
        'syr-SY', // Syriac (Syria)
        'ta-IN', // Tamil (India)
        'te-IN', // Telugu (India)
        'tg-Cyrl-TJ', // Tajik (Cyrillic, Tajikistan)
        'th-TH', // Thai (Thailand)
        'tk-TM', // Turkmen (Turkmenistan)
        'tn-ZA', // Setswana (South Africa)
        'tr-TR', // Turkish (Turkey)
        'tt-RU', // Tatar (Russia)
        'tzm-Latn-DZ', // Tamazight (Latin, Algeria)
        'ug-CN', // Uyghur (PRC)
        'uk-UA', // Ukrainian (Ukraine)
        'ur-PK', // Urdu (Islamic Republic of Pakistan)
        'uz-Cyrl-UZ', // Uzbek (Cyrillic, Uzbekistan)
        'uz-Latn-UZ', // Uzbek (Latin, Uzbekistan)
        'vi-VN', // Vietnamese (Vietnam)
        'wo-SN', // Wolof (Senegal)
        'xh-ZA', // isiXhosa (South Africa)
        'yo-NG', // Yoruba (Nigeria)
        'zh-CN', // Chinese (Simplified, PRC)
        'zh-HK', // Chinese (Traditional, Hong Kong S.A.R.)
        'zh-MO', // Chinese (Traditional, Macao S.A.R.)
        'zh-SG', // Chinese (Simplified, Singapore)
        'zh-TW', // Chinese (Traditional, Taiwan)
        'zu-ZA'  // isiZulu (South Africa)
    ]
};

export default timeInfo;